/*
 * Live Trustpilot TrustScore + review count for the header trust bar, the footer rating
 * and any other text marked up as (stars: see snippets/trustpilot-stars.liquid):
 *
 *   <span data-trustpilot-text="{score} {label} {count_short} reviews">Fallback text</span>
 *
 * Tokens: {score} 4.7 · {stars} 4.5 · {label} Excellent · {count} 8,947 · {count_short} 8.9K
 * The element keeps its server-rendered fallback until the data arrives (or if the API fails).
 *
 * The business unit response is cached in localStorage for CACHE_TTL, so a visitor
 * triggers at most one API request per TTL instead of one per page view.
 */
(function () {
  if (window.TrustpilotSummary) return;

  /* Set in theme.liquid from the "Trustpilot reviews" theme settings */
  var config = window.TrustpilotConfig || {};
  var API_KEY = config.apiKey;
  var BUID = config.buid || '5c2e4995cccdb1000183931a';
  if (!API_KEY) return;
  var CACHE_KEY = 'tp-summary:' + BUID;
  var CACHE_TTL = 6 * 60 * 60 * 1000;

  function readCache() {
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY));
      if (cached && cached.data) return cached;
    } catch (error) {}
    return null;
  }

  function writeCache(data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), data: data }));
    } catch (error) {}
  }

  /* Trustpilot's own TrustScore bands */
  function label(score) {
    if (score >= 4.3) return 'Excellent';
    if (score >= 3.8) return 'Great';
    if (score >= 2.8) return 'Average';
    if (score >= 1.8) return 'Poor';
    return 'Bad';
  }

  function shortCount(total) {
    if (total < 1000) return String(total);
    var value = total / 1000;
    return (value < 10 ? value.toFixed(1).replace(/\.0$/, '') : Math.round(value)) + 'K';
  }

  function tokens(data) {
    var score = (data.score && data.score.trustScore) || 0;
    var total = (data.numberOfReviews && data.numberOfReviews.total) || 0;

    return {
      score: score.toFixed(1),
      stars: String((data.score && data.score.stars) || 0),
      label: label(score),
      count: total.toLocaleString('en-AU'),
      count_short: shortCount(total)
    };
  }

  function apply(data, root) {
    if (!data || !data.numberOfReviews) return;

    var values = tokens(data);
    (root || document).querySelectorAll('[data-trustpilot-text]').forEach(function (element) {
      var template = element.getAttribute('data-trustpilot-text');
      if (!template) return;

      element.textContent = template.replace(/\{(\w+)\}/g, function (match, key) {
        return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
      });
    });

    /* Star boxes: green up to score.stars (Trustpilot rounds it to halves), grey after */
    var stars = Number(data.score && data.score.stars) || 0;
    (root || document).querySelectorAll('[data-trustpilot-stars]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (star, index) {
        var fill = Math.min(Math.max(stars - index, 0), 1) * 100;
        star.style.setProperty('--tp-fill', fill + '%');
      });
    });
  }

  var current = null;

  function load() {
    var cached = readCache();
    if (cached) {
      current = cached.data;
      apply(current);
      if (Date.now() - cached.time < CACHE_TTL) return;
    }

    fetch('https://api.trustpilot.com/v1/business-units/' + encodeURIComponent(BUID), {
      headers: { apikey: API_KEY, Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        current = data;
        writeCache(data);
        apply(data);
      })
      .catch(function (error) {
        console.error('[trustpilot-summary] Trustpilot API failed:', error);
      });
  }

  /* Header/footer sections re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    apply(current, event.target);
  });

  window.TrustpilotSummary = { apply: function (root) { apply(current, root); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})();
